import { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";

const ColumnFilter = ({ currentColumn, filters, onApply, hideMenu }) => {
	const { filterOptions, filterValue, id } = filters[currentColumn.headerName];
	const [currentFilters, setCurrentFilters] = useState(filterValue);
	const componentWillUnmount = useRef(false);
	//Setting up a use effect for when the component unmounts
	useEffect(() => {
		return () => {
			componentWillUnmount.current = true;
		};
	}, []);
	useEffect(() => {
		return () => {
			if (componentWillUnmount.current) {
				onApply(id, currentFilters);
			}
		};
	}, [currentFilters, id, onApply]);
	return (
		<Box
			sx={{
				width: currentColumn.computedWidth,
				maxHeight: 300,
				overflowY: "auto",
				overflowX: "hidden",
			}}
		>
			<MenuItem
				key="select_all"
				onClick={() => {
					if (currentFilters.length === filterOptions.length) {
						setCurrentFilters([]);
					} else {
						setCurrentFilters([...filterOptions]);
					}
				}}
				sx={{ padding: 0 }}
			>
				<Checkbox checked={currentFilters.length === filterOptions.length} />
				<ListItemText style={{ whiteSpace: "normal" }} primary="Select All" />
			</MenuItem>
			{filterOptions.map((value, index) => (
				<MenuItem
					key={index}
					onClick={() => {
						var newFilters = [...currentFilters];
						if (newFilters.includes(value)) {
							setCurrentFilters(
								newFilters.filter((filterVal) => {
									return filterVal !== value;
								})
							);
						} else {
							setCurrentFilters([...currentFilters, value]);
						}
					}}
					sx={{ padding: 0 }}
				>
					<Checkbox checked={currentFilters.indexOf(value) > -1} />
					<ListItemText style={{ whiteSpace: "normal" }} primary={value} />
				</MenuItem>
			))}
			<MenuItem key="applyButton" sx={{ justifyContent: "flex-end" }}>
				<Button
					varient="contained"
					onClick={() => {
						onApply(id, currentFilters);
						hideMenu();
					}}
				>
					Apply
				</Button>
			</MenuItem>
		</Box>
	);
};

export default ColumnFilter;
